import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {setAddress} from '../actions/member';
import { getDefaultAddress } from '../../../selectors/member';
import LocalizedAddress from '../components/LocalizedAddress';
import { TranslationContext } from '../../../../checkout/config/Translations';
import ShippingAddress from "../../../components/ShippingAddress";
import { getSelectedDeliveryOption } from "../../../selectors/delivery";
import { hasDeliverableProducts } from '../../../selectors/product';
import { setDeliveryAddress, validateAndSaveDeliveryAddress } from '../../delivery/actions/delivery';
import { Fragment } from 'react';

class AddressContainer extends Component<ContainerProps> {
    constructor(props) {
      super(props);
      
      this.state = {
          useDeliveryAddress: true,
      };
    }

    render() {
      return (
        <Fragment>
            {this.renderAddress()}
            {this.renderDeliveryAddress()}
        </Fragment>
    );

    }
    renderAddress(){
      return(
        <TranslationContext.Consumer>
        {t =>
            <LocalizedAddress
                {...this.props.address}
                onAddressChange={this.onAddressChange}
                header={t.t('checkout__customer_address')}
            />
        }            
        </TranslationContext.Consumer>
      )
    }

    onAddressChange = (address) => {
      if(!this.props.hasAddress) {
          for (const key in this.props.address) {
              if(this.props.address[key] !== "" && address[key] === "") {
                  address[key] = this.props.address[key];
              }
          }
      }
      this.props.setAddress(address);

      if(this.state.useDeliveryAddress) {
        this.props.setDeliveryAddress({...address});
      }

    }

    renderDeliveryAddress() {
      if(this.props.deliveryOption.method_name === 'Mail' || this.props.hasDeliverableProducts) {
        return (
          <ShippingAddress
            address={this.props.deliveryAddress}
            onAddressChange={this.props.setDeliveryAddress}
            useShippingAddress={this.state.useDeliveryAddress}
            onUseShippingAddressChange={this.onUseDeliveryAddressChange}
            customerAddress={true}
          />
        )
      }
      return null;
    }

  onUseDeliveryAddressChange = () => {
    this.setState({
      useDeliveryAddress: !this.state.useDeliveryAddress,
    });
  }
}

const mapStateToProps = (state) => {
    return {
        address: getDefaultAddress(state),
        hasAddress: state.member.address !== false,
        deliveryOption: getSelectedDeliveryOption(state),
        hasDeliverableProducts: hasDeliverableProducts(state),
        deliveryAddress: state.delivery.address !== false ? state.delivery.address : getDefaultAddress(state),

    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setAddress,
        setDeliveryAddress,
        validateAndSaveDeliveryAddress,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressContainer)
